import { PageType } from "@product/scmp-sdk";
import getDay from "date-fns/getDay";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { tracking } from "shared/data";

import type { todaysReadQuery$key } from "scmp-app/queries/__generated__/todaysReadQuery.graphql";

import { Container, Content, Headline, StyledContentItemPostiesTodaysRead } from "./styles";

type Props = {
  reference: todaysReadQuery$key;
};

export const TodaysRead: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const data = useFragment(
    graphql`
      fragment todaysReadQuery on Query {
        todaysReadQueue: queue(filter: { name: "section_top_515470" }) {
          items(first: 7) {
            edges {
              node {
                ... on Article {
                  ...postiesTodaysReadContentItemContent
                }
              }
            }
          }
        }
      }
    `,
    reference_,
  );

  const customQueryParameters = {
    module: tracking.module.TodaysRead,
    pgtype: tracking.pageType.Content,
  };

  const getNumberOfTheArticle = getDay(new Date()) === 0 ? 6 : getDay(new Date()) - 1;
  const todayArticle = data?.todaysReadQueue?.items?.edges?.[getNumberOfTheArticle];

  if (!todayArticle) return null;

  return (
    <Container>
      <Headline>
        TODAY<span>&apos;</span>S READ
      </Headline>
      <Content>
        <StyledContentItemPostiesTodaysRead
          customQueryParameters={{
            pageType: PageType.PostiesArticle,
            ...customQueryParameters,
          }}
          reference={todayArticle?.node}
        />
      </Content>
    </Container>
  );
};

TodaysRead.displayName = "TodaysRead";
